import { fetchPromoOffers } from './fetchPromoOffers';
import type { IPromoQuerySchema } from '../../repositories/search-offers/entities/query_for_offer_promos/PromoQuerySchema';
import { TPublicWebV1SearchOffersForNewbuildingPromosResponse_1 } from '../../repositories/search-offers/web/v1/search-offers-for-newbuilding-promos';
import { IApplicationContext } from '../../types/applicationContext';

interface IFetchRegionMetaParameters {
  path?: string;
  subdomain: string;
  query?: IPromoQuerySchema;
}

export async function fetchPromoOffersSafe(
  context: IApplicationContext,
  { path, subdomain, query }: IFetchRegionMetaParameters,
): Promise<TPublicWebV1SearchOffersForNewbuildingPromosResponse_1 | null> {
  try {
    return await fetchPromoOffers(context, { path, subdomain, query });
  } catch (e) {
    context.logger.error(e);

    return null;
  }
}
